export default "__VITE_ASSET__BOd7YUJL__"